export default "__VITE_ASSET__DLbrlE98__"